<template>
    <div v-if="isLoaded" class="columns" style="padding: 0 !important">
        <div
                class="column is-3-fullhd is-3-desktop is-4-tablet is-12-mobile today is-vertical-center"
        >
            <div class="is-vertical-center">
                <img
                        class="weather-icon"
                        :src="'/home/images/weather/' + getIconFileName(weather.now.icon)"
                />
                <div>
                    <h2 class="subtitle">{{ installation.location }}</h2>
                    <h2 class="title">
                        {{ parseFloat(weather.now.temperature).toFixed(1) }} º
                    </h2>
                </div>
            </div>
        </div>

        <div
                class="column is-9-fullhd is-9-desktop is-8-tablet is-vertical-center is-hidden-mobile"
        >
            <div class="columns" style="width: 100%">
                <div class="column" :key="key" v-for="(prediction, key) in weather.forecast">
                    <img
                            class="weather-icon"
                            :src="'/home/images/weather/' + getIconFileName(prediction.icon)"
                            alt=""/><br/>
                    {{
                    Math.round(
                        (prediction.temperatureMax + prediction.temperatureMin) / 2
                    )
                    }}
                    º
                    {{ prediction.day }}
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import {mapActions} from "vuex";
import weather from "@/mixins/weather";

export default {
    name: "installation-weather",
    mixins: [weather],
    props: {
        installation: Object,
    },

    data() {
        return {
            isLoaded: false,
            weather: {
                now: {},
                forecast: [],
            },
        };
    },
    computed: {},
    methods: {
        ...mapActions("installations", ["setCurrentWeather"]),
        getDay: function (time) {
            let date = this.moment(time);
            return date.format("ddd");
        },
    },

    mounted() {
        this.setCurrentWeather().then(() => {
            const weather = this.installation.weather
            this.weather.now = {
                icon: weather.current_weather.weathercode,
                temperature: weather.current_weather.temperature
            }

            const forecast = []
            const daily = weather.daily
            for (let i = 1; i <= 6; i++) {
                forecast.push({
                    icon: daily.weathercode[i],
                    temperatureMax: daily.temperature_2m_max[i],
                    temperatureMin: daily.temperature_2m_min[i],
                    day: this.getDay(daily.time[i])
                })
            }

            this.weather.forecast = forecast
            this.isLoaded = true;
        });
    },
};
</script>

<style lang="scss" scoped>
.weather-icon {
  width: 50px;
}

.today {
  padding: 0;

  .weather-icon {
    width: 10em;
  }
}
</style>
